App.filter('isOver75FromBirthdate', function () {
    return function (date) {
        date = date || '';
        if (date) {
            	var date = new Date(date);
        	var preciseMiliseconds = new Date(date.getFullYear() + 75, date.getMonth(), date.getDate()).getTime();
        	var nowMiliseconds = new Date().getTime();

        	return preciseMiliseconds < nowMiliseconds;

        } else {
        	return false;
        }
    };
});
